import { CategoryBasicResponse } from '@bluestone-node-sdk/pim';
import BaseAPIClient from '~/clientUtils/baseApiClient';
import { CopyElectionRequest, ElectionListResponse } from '~/definitions/election';
import {
    AssignElectionProps,
    AssignElectionResponse,
    UpdateElectionProps,
    UpdateElectionResponse,
} from '~/definitions/generalSettings';

class ElectionApi extends BaseAPIClient {
    constructor() {
        super('', {});
    }

    async getElectionById(id: string): Promise<CategoryBasicResponse> {
        return this.request({
            method: 'GET',
            url: `/api/election/${id}`,
        });
    }

    async getElectionList(id: string, data: any): Promise<ElectionListResponse> {
        return this.request({
            method: 'POST',
            url: `/api/election/list/${id}`,
            data,
        });
    }

    async updateElectionSettings(params: UpdateElectionProps): Promise<UpdateElectionResponse> {
        return this.request({
            method: 'PUT',
            url: `/api/election/settings/${params.electionId}`,
            data: { data: params.data },
        });
    }

    async assignToElectionSettings(params: AssignElectionProps): Promise<AssignElectionResponse> {
        return this.request({
            method: 'POST',
            url: `/api/election/settings/${params.electionId}`,
            data: { data: params.data },
        });
    }

    async updateElectionAttributes(id: string, params: any): Promise<any> {
        return this.request({
            method: 'PUT',
            url: `/api/election/${id}/attributes`,
            data: { ...params },
        });
    }

    async assignAttributesToElection(id: string, params: any): Promise<any> {
        return this.request({
            method: 'POST',
            url: `/api/election/${id}/attributes`,
            data: { ...params },
        });
    }

    async copyElection(params: CopyElectionRequest): Promise<any> {
        return this.request({
            method: 'POST',
            url: `/api/election/copy`,
            data: { ...params },
        });
    }
}

const electionApi = new ElectionApi();

export default electionApi;
